<template>
  <el-container>
    <el-main style="width: 100%; height: 100%">
      <div style="margin-bottom: 10px">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item class="item_font">系统设置</el-breadcrumb-item>
          <el-breadcrumb-item
            ><span class="item_font">标签管理</span></el-breadcrumb-item
          >
        </el-breadcrumb>
      </div>
      <div class="searchBox">
        <el-form label-width="0">
          <el-form-item label="" style="width: 30%">
            <el-autocomplete
              size="mini"
              style="width: 100%"
              placeholder="搜索标签名称"
              suffix-icon="el-icon-search"
              v-model="input3"
              :fetch-suggestions="querySearch"
              :trigger-on-focus="false"
              @select="handleSelect"
              @input="inputNothing"
              @focus="searchFocus"
              ref="searchRef"
            >
              <template slot-scope="{ item }">
                <div class="name item_font">{{ item.name }}</div>
              </template>
            </el-autocomplete>
          </el-form-item>
          <el-form-item label="">
            <el-button
              type="primary"
              size="mini"
              @click="addTag"
              class="item_font"
              >添加标签</el-button
            >
          </el-form-item>
        </el-form>
      </div>
      <div class="item_font">
        <!-- {{ tableData.length }} -->
        <el-table
          :data="tableData"
          border
          highlight-current-row
          style="width: 100%"
          :header-cell-style="headerStyle"
          :cell-style="cellStyle"
        >
          <!-- :max-height="tableHeight" -->
          <!-- <el-table-column prop="number" label="编号" class="item_font"></el-table-column> -->
          <el-table-column
            prop="name"
            label="标签"
            class="item_font"
          ></el-table-column>
          <el-table-column prop="color" label="颜色" class="item_font">
            <template slot-scope="scope">
              <div
                :style="{
                  width: '16px',
                  height: '16px',
                  backgroundColor: scope.row.color,
                }"
              ></div>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <div
                style="
                  display: flex;
                  flex-direction: row;
                  justify-content: space-around;
                "
              >
                <el-button
                  type="text"
                  size="small"
                  @click="handleEdit(scope.$index, scope.row)"
                  class="item_font"
                  >编辑</el-button
                >
                <el-button
                  type="text"
                  size="small"
                  v-if="scope.row.type === 1"
                  @click="handleDelete(scope.$index, scope.row)"
                  class="item_font"
                  >删除</el-button
                >
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-dialog
        :title="status === 'add' ? '添加标签' : '修改标签'"
        center=""
        width="25%"
        :visible.sync="dialogVisible"
        :before-close="closeDialog"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
      >
        <el-form
          label-position="left"
          label-width="80px"
          :model="tagForm"
          style="margin-left: 30px; margin-right: 30px"
        >
          <el-form-item label="标签名称"
            ><el-input v-model="tagForm.name"></el-input
          ></el-form-item>
          <el-form-item label="标签颜色">
            <!-- <el-select v-model="tagForm.color" style="width: 100%;" placeholder="请选择">
							<el-option v-for="item in colorOptions" :key="item.value" :label="item.label" :value="item.color.split('#').join('')" :style="{ color: item.color }"></el-option>
						</el-select> -->
            <el-color-picker
              v-model="color"
              :show-alpha="false"
              :predefine="predefineColors"
            >
            </el-color-picker>
          </el-form-item>
          <el-form-item label="备注"
            ><el-input type="textarea" v-model="tagForm.remark"></el-input
          ></el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="closeDialog">取 消</el-button>
          <el-button type="primary" @click="condirmEditTag">确 定</el-button>
        </span>
      </el-dialog>
    </el-main>
  </el-container>
</template>

<script>
import { MessageBox } from "element-ui";
// import $ from "jquery";
export default {
  data() {
    return {
      searchName: "",
      dialogVisible: false,
      input3: "",
      tableData: [],
      tagForm: {
        id: "",
        name: "",
        color: "",
        remark: "",
      },
      predefineColors: [
        "#FF6666",
        "#B05DC9",
        "#FAAD14",
        "#AB7762",
        "#5A9CF8",
        "#62AB76",
      ],
      color: "#B05DC9",
      colorOptions: [
        {
          label: "· 红色",
          value: 1,
          color: "#FF6666",
        },
        {
          label: "· 紫色",
          value: 2,
          color: "#B05DC9",
        },
        {
          label: "· 黄色",
          value: 3,
          color: "#FAAD14",
        },
        {
          label: "· 棕色",
          value: 4,
          color: "#AB7762",
        },
        {
          label: "· 蓝色",
          value: 5,
          color: "#5A9CF8",
        },
        {
          label: "· 绿色",
          value: 6,
          color: "#62AB76",
        },
        {
          label: "· 灰色",
          value: 7,
          color: "#686868",
        },
      ],
      status: "edit",
      tableHeight: 400,
    };
  },

  mounted() {
    this.getAllTag();
    // this.$nextTick(() => {
    //   var seaH = $(".searchBox").height();
    //   this.tableHeight = window.innerHeight - seaH - 180;
    //   window.addEventListener("resize", () => {
    //     //监听浏览器窗口大小改变
    //     //浏览器变化执行动作
    //     var seaH = $(".searchBox").height();
    //     this.tableHeight = window.innerHeight - seaH - 180;
    //   });
    // });
  },
  methods: {
    searchFocus() {
      this.$refs.searchRef.activated = false;
    },
    headerStyle({ rowIndex, columnIndex }) {
      if (rowIndex == 0 && columnIndex == 3) {
        return "text-align:center;color:#000000";
      } else {
        return "text-align:left;padding:15px;color:#000000";
      }
    },
    cellStyle({ columnIndex }) {
      if (columnIndex == 3) {
        return "text-align:center";
      } else {
        return "text-align:left;padding:15px;";
      }
    },
    // 关闭对话框
    closeDialog() {
      this.dialogVisible = false;
      this.tagForm = {
        id: "",
        name: "",
        color: "",
        remark: "",
      };
    },
    // 查询所有标签
    async getAllTag() {
      var api = "/manager/labelLnUser/settingSwitchAll";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
        data: {
          searchValue: this.input3,
        },
      });
      console.log("getAllTag response.data:", response.data);
      for (var i in response.data.labelVoAllList) {
        response.data.labelVoAllList[i].color =
          "#" + response.data.labelVoAllList[i].color;
      }
      this.tableData = response.data.labelVoAllList;
      console.log("标签总数据：", this.tableData);
    },
    // 隐藏不能修改的标签
    tableRowClassName({ row }) {
      if (row.type == 2) {
        return "hidden_box";
      } else {
        return "";
      }
    },
    // 编辑标签
    handleEdit(index, row) {
      this.status = "edit";
      console.log("handleEdit", index, row);
      this.dialogVisible = true;
      this.tagForm.name = row.name;
      this.tagForm.remark = row.remark;
      this.tagForm.id = row.id;
      this.color = row.color;
    },
    // 提交标签表单内容
    async condirmEditTag() {
      if (this.color === null) {
        console.log("颜色为空");
        const tipMsg = "标签颜色不能为空";
        this.$message.error(tipMsg);
      } else {
        this.tagForm.color = this.color.split("#").join("");
        console.log("TagManager condirmEditTag tagForm = ", this.tagForm);
        var api = "/manager/label/edit";
        const response = await this.util.postRequest({
          url: api,
          method: "POST",
          data: this.tagForm,
        });
        if (response.resultCode === "10000") {
          this.dialogVisible = false;
          this.tagForm = {
            id: "",
            name: "",
            color: "",
            remark: "",
          };
          this.getAllTag();
          const tip = this.status == "edit" ? "修改成功" : "创建成功";
          this.$message.success(tip);
        } else {
          this.$message.error(response.desc);
        }
      }
    },
    // 删除标签
    async handleDelete(scope, row) {
      const tipMsg = "是否确认删除(删除该标签，报表中该标签无法正常显示)";
      MessageBox.alert(tipMsg, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        showCancelButton: true,
      })
        .then(() => {
          this.deleteTag(row.id);
        })
        .catch(() => {
          this.$message.info("取消删除");
        });
    },
    async deleteTag(id) {
      console.log(id);
      var api = "/manager/label/del";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
        data: {
          id: id,
        },
      });
      if (response.resultCode === "10000") {
        this.getAllTag();
        this.$message.success("删除成功");
      } else {
        this.$message.error(response.desc);
      }
    },
    // 搜索标签名称
    querySearch(queryString, cb) {
      var tableData = this.tableData;
      var results = queryString
        ? tableData.filter(this.createFilter(queryString))
        : tableData;
      console.log("查询结果", queryString, cb);
      this.getAllTag();
      cb(results);
    },
    createFilter(queryString) {
      return (data) => {
        return data.name.toLowerCase().indexOf(queryString.toLowerCase()) === 0;
      };
    },
    handleSelect(item) {
      console.log(item);
      // this.input3 = item.name;
      // for (var i = 0; i < this.tableData.length; i++) {
      //   console.log("当前循环", this.tableData[i]);
      //   if (this.tableData[i].name == item.name) {
      //     this.tableData = [];
      //     this.tableData.push(item);
      //   }
      // }
      // console.log("当前数据", this.tableData);
    },
    inputNothing(val) {
      if (typeof val !== "undefined") {
        console.log(typeof val);
        console.log("输入值发生改变", val);
        this.getAllTag();
      }
    },
    addTag() {
      this.dialogVisible = true;
      this.status = "add";
    },
  },
};
</script>

<style>
.top {
  /* background-color: #000000; */
  width: 80%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}

.el-table .hidden_box {
  display: none;
}
</style>
